const positions = new WeakMap();

export const getConversationRouteId = context => {
  const route = context.rootState.route;
  const id =
    route?.params?.conversation_id ||
    route?.params?.conversationId ||
    (route?.name === 'inbox_view_conversation' ? route.params.id : null);
  return id ? Number(id) : null;
};

const selectedId = context => {
  return Number(
    getConversationRouteId(context) ||
      context.rootState.conversations?.selectedChatId
  );
};

const currentPosition = context => {
  const position = positions.get(context.rootState);
  if (
    position &&
    position.accountId === context.rootGetters.getCurrentAccountId &&
    position.userId === context.rootGetters.getCurrentUserID &&
    position.conversationId === selectedId(context)
  ) {
    return position;
  }
  positions.delete(context.rootState);
  return null;
};

// This is a short-lived geometric bookmark, never a cache of message content.
export const rememberConversationPosition = (context, bookmark) => {
  const existing = currentPosition(context);
  if (existing?.restoring || bookmark.conversationId !== selectedId(context)) {
    return;
  }
  const anchorId = Number(bookmark.anchorId);
  if (!bookmark.atEnd && (!Number.isInteger(anchorId) || anchorId < 1)) return;
  positions.set(context.rootState, {
    accountId: context.rootGetters.getCurrentAccountId,
    userId: context.rootGetters.getCurrentUserID,
    conversationId: bookmark.conversationId,
    anchorId: bookmark.anchorId,
    offset: bookmark.offset,
    atEnd: bookmark.atEnd,
    restoring: false,
  });
};

export const beginConversationPositionRestore = context => {
  const position = currentPosition(context);
  if (position) position.restoring = true;
};

export const getConversationPositionRestore = (context, conversationId) => {
  const position = currentPosition(context);
  return position?.restoring && position.conversationId === conversationId
    ? position
    : null;
};

export const finishConversationPositionRestore = (context, position) => {
  if (currentPosition(context) === position) position.restoring = false;
};

export const clearConversationPosition = rootState => {
  positions.delete(rootState);
};
